export default __webpack_public_path__ + "static/media/mission.cdd7f630.jpg";